import { Stack, XStack } from '@my/ui'
import { OfferCard } from '../offer-card'

export const OfferList = ({ items }: { items: any[] }) => {
  return (
    <XStack gap="$3.5" flexWrap="wrap" $gtMd={{ rowGap: '$5' }}>
      {(items || []).map((item, i) => (
        <Stack width="100%" key={`${item.id}-${i}`} $gtXs={{ width: 'calc(50% - 8px)' }}>
          <OfferCard {...item} />
        </Stack>
      ))}
    </XStack>
  )
}
